import SSBadge from "@core-components/Badge";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { IconPlus } from "@tabler/icons-react";

interface ICoinsGainedBadgeProps {
  coins: number;
}

const CoinsGainedBadge: React.FC<ICoinsGainedBadgeProps> = ({ coins = 0 }) => {
  const { t } = useAppTranslation("pages.clientDashboard.components");
  return (
    <SSBadge
      color={{
        background: "#302A19",
        text: "#FECA21",
        border: "#FECA21",
      }}
      leftSection={<IconPlus size={20} />}
      capitalize={false}
      className="gap-[0.5px] pr-[5px] pl-1"
    >
      {t("coinsGainedBadge.label", { count: coins })}
    </SSBadge>
  );
};

export default CoinsGainedBadge;
